import { matchPath } from 'react-router-dom';
import { ReactNode } from 'react';
import { BreadcrumbRoute } from 'types/breadcrumbs';

export interface ResolvedBreadcrumb {
  title: ReactNode | string;
  url?: string;
}

export const findBreadcrumbs = (
  pathname: string,
  routes: BreadcrumbRoute[],
  data?: Record<string, string>
): ResolvedBreadcrumb[] | null => {
  for (const route of routes) {
    const match = matchPath(route.pattern, pathname);
    if (match) {
      const params = match.params as Record<string, string>;
      return route.breadcrumbs.map((bc) => ({
        title: typeof bc.title === 'function' ? bc.title(params, data) : bc.title,
        url: typeof bc.url === 'function' ? bc.url(params, data) : bc.url
      }));
    }
  }
  return null;
};
